import * as t from "io-ts";
import { DateFromISOString } from "io-ts-types";
import { Tier } from "./Tier";

export const TierEvent = t.type({
  tier: Tier,
  action: t.union([t.literal("add_tier"), t.literal("remove_tier")]),
  actioned_at: DateFromISOString,
});

export interface TierEvent {
  tier: Tier;
  action: "add_tier" | "remove_tier";
  actioned_at: Date;
}
